import { AnchorButton, Tooltip } from '@blueprintjs/core';
import {
  lock_hooks,
  useMarkApplicationAsDuplicate,
} from '@axo/shared/data-access/hooks';

export function MarkAsDuplicateButton({
  applicationID,
  marketCountry,
}: {
  applicationID: string;
  marketCountry: string;
}) {
  const markAsDuplicate = useMarkApplicationAsDuplicate();
  const hasLock = lock_hooks.useCurrentUserHasLock(
    applicationID,
    marketCountry
  ).data;

  const handleMarkAsDuplicate = async () => {
    await markAsDuplicate.mutateAsync(applicationID);
  };

  return (
    <Tooltip
      disabled={hasLock}
      content={
        <span>This action requires you to have locked the application.</span>
      }
    >
      {/* Tooltip2 must use AnchorButton as target. See: https://blueprintjs.com/docs/#core/components/tooltip */}
      <AnchorButton
        intent="none"
        icon="duplicate"
        onClick={handleMarkAsDuplicate}
        loading={markAsDuplicate.isLoading}
        disabled={!hasLock}
      >
        Mark as duplicate
      </AnchorButton>
    </Tooltip>
  );
}
